import { reloadDatatable } from "../common/datatables";

const props = {
    userManagementDatatableMarker: '.marker-user-management',
    userManagementDatatable: '#dt-user-management',
    searchterm_selector: '#SearchField',
    usertype_selector: 'input[name=usertype]',
    userstatus_selector: 'input[name=userstatus]'
};

const setupSearchValueTextboxEvents = () => {

    //PURPOSE: initialises events associated with the text search field
    $(props.searchterm_selector).off("keypress").on('keypress', (e) => {
        if (e.which === 13) {
            e.preventDefault();

            reloadUserManagementDatatable();
        }
    });

    $(props.usertype_selector).off("change").on("change", () => {

        reloadUserManagementDatatable();
    });

    $(props.userstatus_selector).off("change").on("change", () => {

        reloadUserManagementDatatable();
    });
};

const setupUserSearchButtonEvent = () => {
    //PURPOSE: initialises search button click event
    $('.mdc-text-field__icon').off("click").on('click', (e) => {
        reloadUserManagementDatatable();
    });
};

const reloadUserManagementDatatable = () => {
    //PURPOSE: reloads user management datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable(props.userManagementDatatable, initUserManagementDatatableEvents, true);
};

export function initUserManagementDatatableEvents() {

    //PURPOSE: sets up the full row click select for the user search dt
    $(props.userManagementDatatable).off('click').on('click', 'tbody td', function (event) {

        if ($(this).hasClass('dataTables_empty')) {

            //if no results are returned for a datatable it adds the message as a row.
            //as such this event binder still acts when theres no row to click through on.
            //the check above neutralises this issue
            return;
        }

        var userId = $(event.currentTarget).parent('tr').data('id');

        window.location.href = '/administration/user/edit/' + userId;
    });
}

let userManagementDatatable;
export function dtAdminUserManagement(onloadCallback, searchterm_selector, usertype_selector, userstatus_selector) {

    console.log("Init Admin User Management Datatables");

    if ($(props.userManagementDatatable).length === 0) return false;

    //ML - do we need to do this if we set destroy: true? in config below
    if (userManagementDatatable) userManagementDatatable.destroy();

    // Declared above so can be accessed later (during page lifecycle)
    userManagementDatatable = $(props.userManagementDatatable).DataTable({
        iDisplayLength: 50,
        initComplete: onloadCallback,
        paging: true,
        info: true,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/user/searchuseraccounts',
            data: function (d) {
                d.searchterm = $(searchterm_selector).val();

                if ($(usertype_selector).length > 0) {
                    d.usertype = $(usertype_selector + ':checked').val();
                }

                if ($(userstatus_selector).length > 0) {
                    d.userstatus = $(userstatus_selector + ':checked').val();
                }
            },

            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'name', name: 'Name' },
            { data: 'email', name: 'Email' },
            { data: 'entityStatus', name: 'Status' },
            { data: 'createdDate', name: 'Created Date' }
        ],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}

export function initDtAdminUserManagement() {

    if ($(props.userManagementDatatableMarker).length) {
        dtAdminUserManagement(initUserManagementDatatableEvents, props.searchterm_selector, props.usertype_selector, props.userstatus_selector);
        setupSearchValueTextboxEvents();
        setupUserSearchButtonEvent();
    }

}